import { useState } from "react";
import { useRouter } from "next/router";
import useFeatureFlag from "src/lib/hooks/useFeatureFlag";
import { MergedProductVariant } from "src/lib/services/catalog/types";

export function useDefaultVariant(
  variantFromProps: MergedProductVariant,
  defaultVariantB?: MergedProductVariant | null
) {
  const router = useRouter();
  const { value } = useFeatureFlag("default-product-variant");
  const [variant, setVariant] = useState(variantFromProps);

  if (value === "variant" && defaultVariantB && !router.query.variant) {
    return [defaultVariantB, setVariant] as const;
  }

  return [variant, setVariant] as const;
}
